import { useQuery } from "@tanstack/react-query";
import { fetchNearbyBusinesses } from "../../apis/business";

export function useNearbyBusinesses(businessId: string) {
  return useQuery({
    queryKey: ["nearbyBusinesses", businessId],
    queryFn: () => fetchNearbyBusinesses(businessId),
    enabled: Boolean(businessId),
  });
} 